module.exports = __webpack_public_path__ + "static/media/dashboardIconTrans.537e7f3b.svg";